import * as yup from 'yup'

import { FormFields } from './types'

export const validationSchema = yup.object().shape({
  [FormFields.title]: yup.string().required().min(1),
  [FormFields.description]: yup.string().max(2048),
  [FormFields.coverImage]: yup.string(),
  [FormFields.coverImageResourceId]: yup.number(),
  [FormFields.thumbnailImage]: yup.string(),
  [FormFields.thumbnailImageResourceId]: yup.number(),
})
